export default __webpack_public_path__ + "static/media/SackTrolley.2656ffe9.jpg";